export default __webpack_public_path__ + "static/media/discord.dd411a15.svg";